import React from 'react';
import {connect} from "react-redux";
import {changeStepAction, scrollToStepAction, setNextStepAction} from "../../../redux/flow-reducer";
import Project from "./Project";

const mapStateToProps = state => {

    let obj = {
        flow:state.flow
    }

    return obj;
}

const mapDispatchToProps = dispatch => {

    let obj = {
        setNextStep: (nextStep) => {dispatch(setNextStepAction(nextStep));},
        changeStep: ()          => {dispatch(changeStepAction());},
        scrollToStep: (stepId)  => {dispatch(scrollToStepAction(stepId));}
    }

    return obj;
}

const ProjectContainer = connect(mapStateToProps, mapDispatchToProps)(Project);

export default ProjectContainer;